// Central business info — edit here to update the whole site.
export const BUSINESS = {
  name: "iCrack Solutions",
  brandTagline: "The Phone & Computer Repair Specialist",
  legalArea: "Eastleigh, Hampshire",
  address: {
    line1: "94 Market Street",
    city: "Eastleigh",
    region: "Hampshire",
    postcode: "SO50 5RE",
    country: "United Kingdom",
  },
  phones: [
    { label: "Primary", display: "07930 305 875", tel: "+447930305875" },
    { label: "Secondary", display: "07898 873 615", tel: "+447898873615" },
  ],
  email: "info@icracksolutions.co.uk",
  whatsapp: {
    number: "447898873615",
    href: "https://wa.me/447898873615?text=Hi%20iCrack%2C%20I%27d%20like%20to%20book%20a%20repair.",
  },
  googleBusinessUrl: "https://share.google/gmrVN5OsZBg1QRZcV",
  googleMapsEmbed:
    "https://www.google.com/maps?q=94+Market+Street+Eastleigh+SO50+5RE&output=embed",
  googleDirections:
    "https://www.google.com/maps/dir/?api=1&destination=94+Market+Street+Eastleigh+SO50+5RE",
  rating: { score: 4.9, count: 294 },
  // Labour rate is for CALL-OUT (home / office visits) only. In-store repairs are fixed-price.
  callOutLabourRate: 120,
  hours: [
    { day: "Mon", open: "09:00", close: "18:00" },
    { day: "Tue", open: "09:00", close: "18:00" },
    { day: "Wed", open: "09:00", close: "18:00" },
    { day: "Thu", open: "09:00", close: "18:00" },
    { day: "Fri", open: "09:00", close: "18:00" },
    { day: "Sat", open: "09:00", close: "18:00" },
    { day: "Sun", open: "10:00", close: "17:00" },
  ],
  coverage: ["Eastleigh", "Southampton", "Winchester", "Fareham", "Portsmouth", "Hampshire", "Surrey", "Guildford", "Woking", "Farnborough"],
  storefrontImage:
    "https://customer-assets.emergentagent.com/job_d4350c6f-1915-4ab9-a76b-c60fc11129ba/artifacts/kl4g89fl_image.png",
  workshopImage:
    "https://images.unsplash.com/photo-1580910051074-3eb694886505?auto=format&fit=crop&w=1600&q=80",
};

// Hero rotating images (5 slides). Storefront is anchor.
export const HERO_SLIDES = [
  {
    src: BUSINESS.storefrontImage,
    alt: "iCrack Solutions storefront at 94 Market Street, Eastleigh",
    caption: "Our shop — 94 Market Street, Eastleigh",
  },
  {
    src: "https://images.unsplash.com/photo-1512428559087-560fa5ceab42?auto=format&fit=crop&w=1200&q=80",
    alt: "Technician repairing an iPhone screen with precision tools",
    caption: "iPhone screen replacements while you wait",
  },
  {
    src: "https://images.unsplash.com/photo-1601784551446-20c9e07cdbdb?auto=format&fit=crop&w=1200&q=80",
    alt: "Close-up of a phone battery being replaced",
    caption: "Phone & MacBook batteries — same-day",
  },
  {
    src: "https://images.unsplash.com/photo-1517336714731-489689fd1ca8?auto=format&fit=crop&w=1200&q=80",
    alt: "MacBook Pro being serviced on a workshop desk",
    caption: "MacBook, iMac & laptop repairs",
  },
  {
    src: "https://images.unsplash.com/photo-1580910051074-3eb694886505?auto=format&fit=crop&w=1200&q=80",
    alt: "Repair workshop bench with tools and devices",
    caption: "Trusted repair specialists in Hampshire & Surrey",
  },
];

export const SERVICES = [
  { slug: "iphone-repair", title: "iPhone Repair", icon: "Smartphone", short: "Screens, batteries, cameras, charging ports for all iPhone models.", image: "https://images.unsplash.com/photo-1592899677977-9c10ca588bbd?auto=format&fit=crop&w=800&q=80" },
  { slug: "android-repair", title: "Android Repair", icon: "Smartphone", short: "Samsung, Google, Huawei, Xiaomi & more — screens & internals.", image: "https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?auto=format&fit=crop&w=800&q=80" },
  { slug: "ipad-tablet", title: "iPad & Tablet Repair", icon: "Tablet", short: "Cracked screens, digitizers, batteries, home buttons.", image: "https://images.unsplash.com/photo-1544244015-0df4b3ffc6b0?auto=format&fit=crop&w=800&q=80" },
  { slug: "macbook-repair", title: "MacBook & iMac Repair", icon: "Laptop", short: "Keyboards, screens, batteries, logic-board diagnostics.", image: "https://images.unsplash.com/photo-1541807084-5c52b6b3adef?auto=format&fit=crop&w=800&q=80" },
  { slug: "pc-laptop", title: "Laptop & PC Repair", icon: "Monitor", short: "Windows laptops & desktops — hardware, software, virus removal.", image: "https://images.unsplash.com/photo-1587202372634-32705e3bf49c?auto=format&fit=crop&w=800&q=80" },
  { slug: "battery", title: "Battery Replacement", icon: "BatteryCharging", short: "Genuine-quality batteries, tested & sealed properly.", image: "https://images.unsplash.com/photo-1601784551446-20c9e07cdbdb?auto=format&fit=crop&w=800&q=80" },
  { slug: "water-damage", title: "Water Damage Repair", icon: "Droplets", short: "Full ultrasonic clean + component-level diagnostics.", image: "https://images.unsplash.com/photo-1512428559087-560fa5ceab42?auto=format&fit=crop&w=800&q=80" },
  { slug: "charging-port", title: "Charging Port Repair", icon: "Plug", short: "Loose or dead ports — micro-soldered where needed.", image: "https://images.unsplash.com/photo-1580910051074-3eb694886505?auto=format&fit=crop&w=800&q=80" },
  { slug: "data-recovery", title: "Data Recovery", icon: "HardDrive", short: "Photos, messages, contacts — recovered from most devices.", image: "https://images.unsplash.com/photo-1587202372634-32705e3bf49c?auto=format&fit=crop&w=800&q=80" },
  { slug: "software", title: "Software & Virus Removal", icon: "ShieldCheck", short: "OS reinstall, virus removal, speed-ups, backups.", image: "https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?auto=format&fit=crop&w=800&q=80" },
  { slug: "buy-sell", title: "Buy & Sell Phones", icon: "Store", short: "Trade in your old device or grab a tested pre-owned one.", image: "https://images.unsplash.com/photo-1592899677977-9c10ca588bbd?auto=format&fit=crop&w=800&q=80" },
  { slug: "accessories", title: "Accessories", icon: "Headphones", short: "Cases, chargers, cables, power banks & headphones.", image: "https://images.unsplash.com/photo-1585060544812-6b45742d762f?auto=format&fit=crop&w=800&q=80" },
];

export const PRICING_EXAMPLES = [
  { title: "iPhone Screen Replacement", from: 39, note: "From — model dependent, fitted while you wait" },
  { title: "iPhone Battery Replacement", from: 29, note: "From — genuine-quality, sealed correctly" },
  { title: "Samsung Screen Replacement", from: 49, note: "From — OLED where required" },
  { title: "iPad Screen Replacement", from: 59, note: "From — digitizer + adhesive fitted" },
  { title: "MacBook Battery", from: 79, note: "From — model dependent" },
  { title: "Diagnostic + Report", from: 0, note: "Free in-store • No fix no fee" },
];

export const FAQS = [
  {
    group: "Turnaround",
    items: [
      { q: "How long does a phone repair take?", a: "Most iPhone and Android screen or battery replacements are done in 30–60 minutes while you wait in store. Complex Mac or water-damage jobs are typically same-day or next-day." },
      { q: "Do I need to book, or can I walk in?", a: "Walk-ins are welcome. Booking online guarantees a slot and lets us prepare the parts in advance, so you're seen quicker." },
    ],
  },
  {
    group: "Pricing",
    items: [
      { q: "How much do in-store repairs cost?", a: "In-store repairs are fixed-price and quoted before we start. Most common jobs (iPhone screen, battery, charging port) start from £29–£69. We always give an exact quote after a free diagnostic." },
      { q: "What does a call-out visit cost?", a: "For home or office visits we charge a flat £120/hour for labour, plus any parts needed. There is no call-out fee — you only pay for the time on the job." },
      { q: "Do you offer 'No Fix, No Fee'?", a: "Yes. If we cannot fix your device, you don't pay for the labour. Diagnostic reports are free in store." },
    ],
  },
  {
    group: "Call-out service",
    items: [
      { q: "What can you repair on a call-out visit?", a: "Everything we do in-store: iPhones, Android phones, iPads, tablets, MacBooks, iMacs, Windows laptops and desktop PCs — including screens, batteries, charging ports, water damage assessments, keyboards, RAM/SSD upgrades and software." },
      { q: "Which areas do you cover for call-out?", a: "We cover Eastleigh, Southampton and the wider Hampshire area, plus Surrey (including Guildford, Woking, Farnborough)." },
      { q: "Can you fix my Mac or laptop at my home or office?", a: "Yes — most repairs can be completed on-site. For anything requiring a workshop bench (deep water damage, board-level micro-soldering) we can collect the device and return it once fixed." },
    ],
  },
  {
    group: "Warranty & Data",
    items: [
      { q: "Is there a warranty on repairs?", a: "Yes — a standard 3-month warranty is included on most parts and workmanship. Batteries and specialist parts have their own warranty terms explained on collection." },
      { q: "Will I lose my data during a repair?", a: "Screen and battery repairs do not affect your data. For water-damage or motherboard work we always recommend a backup — we can also help you back up in store." },
      { q: "Do you buy old phones?", a: "Yes — we buy, sell and trade-in phones. Bring your device in for a free instant quote." },
    ],
  },
];

// Real customer reviews sourced from the iCrack Solutions Google Business Profile.
export const REVIEWS = [
  { name: "Tktk Dekuu", device: "iPhone screen", stars: 5, quote: "Great service, fixed broken iPhone screen super quickly and good price." },
  { name: "Ejaz Ahmad", device: "In-store visit", stars: 5, quote: "A top class customer service and quality stuff." },
  { name: "Esonwune C.", device: "Phone repair", stars: 5, quote: "Cheaper place in all market street — highly recommended." },
];

// Areas we cover — each becomes an SEO-focused landing page at /areas/:slug
export const AREAS = [
  {
    slug: "eastleigh", name: "Eastleigh", region: "Hampshire", postcodePrefix: "SO50",
    blurb: "iCrack Solutions is based right on Market Street in the heart of Eastleigh. Walk in for same-day repairs on iPhones, Androids, iPads, MacBooks, laptops and PCs — or book a mobile call-out to your home or office.",
    landmarks: ["Swan Centre", "Market Street", "Eastleigh Station", "Chandler's Ford", "Hedge End"],
  },
  {
    slug: "southampton", name: "Southampton", region: "Hampshire", postcodePrefix: "SO14–SO19",
    blurb: "Fast, reliable phone, iPad, MacBook and laptop repair for Southampton. Walk in at our Eastleigh workshop — just 10 minutes away — or book a mobile call-out anywhere in the city, from Bevois Valley to Bitterne, Portswood to Shirley.",
    landmarks: ["West Quay", "University of Southampton", "Bitterne", "Portswood", "Ocean Village", "Shirley"],
  },
  {
    slug: "winchester", name: "Winchester", region: "Hampshire", postcodePrefix: "SO22–SO23",
    blurb: "Trusted device repair specialists serving Winchester. Whether it's a cracked iPhone screen or a MacBook that won't boot, our mobile technician can come to you — no call-out charge across Winchester and the surrounding villages.",
    landmarks: ["Winchester Cathedral", "High Street", "University of Winchester", "Kings Worthy", "Twyford"],
  },
  {
    slug: "fareham", name: "Fareham", region: "Hampshire", postcodePrefix: "PO14–PO16",
    blurb: "Fareham's go-to repair specialists for phones, iPads, MacBooks and laptops. Drop in to our Eastleigh workshop or arrange a Fareham call-out. Same-day repairs, transparent pricing, no fix no fee.",
    landmarks: ["Fareham Shopping Centre", "Portchester", "Titchfield", "Whiteley", "Locks Heath"],
  },
  {
    slug: "portsmouth", name: "Portsmouth", region: "Hampshire", postcodePrefix: "PO1–PO6",
    blurb: "Portsmouth phone, tablet and laptop repair without leaving your home. Our mobile technician covers the whole of Portsmouth, Southsea, Cosham and Havant — with no call-out charge and same-day booking when slots are free.",
    landmarks: ["Gunwharf Quays", "Southsea", "Cosham", "Havant", "University of Portsmouth"],
  },
  {
    slug: "chandlers-ford", name: "Chandler's Ford", region: "Hampshire", postcodePrefix: "SO53",
    blurb: "Chandler's Ford is right next door to our Eastleigh shop — pop in for same-day iPhone, iPad or laptop repairs, or book a mobile visit at a time that suits you.",
    landmarks: ["Fryern Arcade", "Hiltingbury", "Valley Park", "Hocombe"],
  },
  {
    slug: "hedge-end", name: "Hedge End", region: "Hampshire", postcodePrefix: "SO30",
    blurb: "Hedge End residents — no need to travel to a big-city repair chain. Fast, honest repairs on all Apple and Android devices, MacBooks and Windows laptops. In-store or call-out.",
    landmarks: ["Hedge End Retail Park", "West End", "Botley", "Netley"],
  },
  {
    slug: "romsey", name: "Romsey", region: "Hampshire", postcodePrefix: "SO51",
    blurb: "Broken screen, dying battery or a laptop that won't switch on? Romsey — we've got you covered. Book online for a call-out or bring your device to our Eastleigh workshop.",
    landmarks: ["Romsey Abbey", "The Hundred", "Nursling", "North Baddesley"],
  },
  {
    slug: "guildford", name: "Guildford", region: "Surrey", postcodePrefix: "GU1–GU5",
    blurb: "Trusted mobile phone, iPad, Mac and PC repair for Guildford. Our technician travels to your home or office anywhere in central Guildford, Merrow, Onslow Village or the wider GU postcode — with no call-out charge.",
    landmarks: ["High Street", "University of Surrey", "Merrow", "Onslow Village", "Burpham"],
  },
  {
    slug: "woking", name: "Woking", region: "Surrey", postcodePrefix: "GU21–GU24",
    blurb: "Woking's local device repair experts. Cracked screens, battery replacements, water-damage recovery, MacBook & PC repair — we come to you across the borough with a flat labour rate and no call-out fee.",
    landmarks: ["Woking Station", "Jubilee Square", "Knaphill", "Horsell", "Byfleet"],
  },
  {
    slug: "farnborough", name: "Farnborough", region: "Surrey / Hampshire border", postcodePrefix: "GU14",
    blurb: "Farnborough residents and businesses — book a call-out for phone, tablet, Mac or laptop repairs. Perfect for busy professionals who can't drop devices off during the day.",
    landmarks: ["Farnborough Main", "Cove", "North Camp", "Aldershot border"],
  },
  {
    slug: "camberley", name: "Camberley", region: "Surrey", postcodePrefix: "GU15–GU17",
    blurb: "Camberley call-out repairs for phones, iPads, laptops and Macs. Free diagnostics, no-fix-no-fee and a 3-month warranty as standard.",
    landmarks: ["The Mall", "Frimley", "Sandhurst", "Yorktown"],
  },
  {
    slug: "aldershot", name: "Aldershot", region: "Hampshire / Surrey border", postcodePrefix: "GU11–GU12",
    blurb: "Aldershot phone, tablet and computer repair, at your door. Our technician handles everything from iPhone screens to full MacBook logic-board diagnostics.",
    landmarks: ["Wellington Centre", "North Camp", "Cove", "Ash Vale"],
  },
  {
    slug: "farnham", name: "Farnham", region: "Surrey", postcodePrefix: "GU9–GU10",
    blurb: "Trusted mobile repair specialists serving Farnham. Same-day slots when available, fair pricing and a friendly, no-jargon approach.",
    landmarks: ["Castle Street", "The Borough", "Weybourne", "Rowledge"],
  },
];
